import type { ConnectionState } from 'ts-components/PiChat/reducer';

type Send = (text: string) => Promise<boolean>;

/**
 * Refuses a send unless the session is `ready` or `idle`: a socket that is
 * open but still handshaking accepts sends, and an `idle` send resumes first.
 */
export const gatedSend =
  (getState: () => ConnectionState, getSend: () => Send | undefined): Send =>
  (text) => {
    const send = getSend();
    const state = getState();
    return send && (state === 'ready' || state === 'idle')
      ? send(text)
      : Promise.resolve(false);
  };
